import React from 'react';
import PropTypes from 'prop-types';
import Ballons from 'assets/images/ballons.svg';
import { useTranslation } from 'react-i18next';
import { Button } from '@ontruck/orc';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'utils/constants/routes';
import { sendEventToSegment } from 'utils/functions/Tracking';
import TRACKING_EVENTS from 'utils/constants/trackingEvents';

const BannerNewUser = ({ className }) => {
  const { t } = useTranslation('Banner');
  const history = useHistory();
  const onNewUserClick = () => {
    history.push(ROUTES.ACCOUNT_SETTINGS);
    sendEventToSegment(TRACKING_EVENTS.BANNER_NEW_USER_PWD_CREATE);
  };

  return (
    <div className={className} data-testid="banner-new-user">
      <div className="banner-new-user">
        <img
          className="banner-new-user__image"
          src={Ballons}
          alt="new-user-ballons"
        />
        <div className="banner-new-user__title">{t('BannerNewUserTitle')}</div>
        <div className="banner-new-user__body">{t('BannerNewUserBody')}</div>
        <Button
          skin="primary"
          className="banner-new-user__action"
          onClick={onNewUserClick}
          text={t('BannerNewUserAction')}
        />
      </div>
    </div>
  );
};
BannerNewUser.propTypes = {
  className: PropTypes.string
};
export default BannerNewUser;
